export const CHANGE_LOCALE = "CHANGE_LOCALE";

export const changeLocale = (locale: string) => ({
  type: CHANGE_LOCALE,
  locale
});
